<div class="mybets-empty popup-body mybets_filter_button">
    @if (hasFilter) {
        <div class="mybets-empty__filter-button clearfix" [class.mybets-empty_state-nonepcot]="!emptyBetsImg">
            <ms-my-bets-filter
                [inColumn]="inColumn"
                [filterConstraint]="filterConstraint"
                [myBetsListContext]="myBetsListContext"
                (filterChanged)="onFilterChanged($event)" />
        </div>
    }
    <div class="mybets-empty-header" [class.mybets-empty-with-filter]="isMyBetsEmptyStateWithFilter">
        @if (emptyBetsImg) {
            <img
                width="{{ emptyBetsImg.width }}"
                height="{{ emptyBetsImg.height }}"
                alt="{{ emptyBetsImg.alt }}"
                priority
                [ngSrc]="emptyBetsImg.src"
                (load)="emptyImgLoaded()" />
        } @else {
            <vn-icon class="mybets-empty-header_icon" name="theme-mybet-emptystate" size="80" />
        }
        @if (showLabels) {
            <span class="mybets-empty-header_label">{{ emptyListMessage }}</span>
            @if (emptyListSubMessage) {
                <span class="mybets-empty-header_sublabel">{{ emptyListSubMessage }}</span>
            }
            @if (showBrowseSportsBook) {
                <button ds-button variant="filled" kind="primary" size="large" class="mybets-empty-header_button" (click)="close()">
                    {{ browseSportsBook }}
                </button>
            }
        }
    </div>
</div>
